// extracted by mini-css-extract-plugin
export default {"body-1":"iUu_c9vmA7v7nfW_JMfN","body-2":"BuFQ6rJy9gBByTFhS4q1","body-3":"_55osg3YkgnkGdgs6Y1Xv","ant-typography":"MJElDtNXK4UVEkTbztTA","searchIcon":"j9rQiBaw9R7FUB1qFyBT"};